import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.scss']
})
export class PlanningComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Planning');
  }

}
